var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"modal-center","size":"lg","header-border-variant":"white","hide-footer":"","hide-header":"","centered":""}},[_c('div',{attrs:{"id":"header"}},[_vm._t("head")],2),_c('div',{attrs:{"id":"form"}},[_vm._t("form")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }